/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 14:31:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 16:19:12
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { get } from 'lodash';
import { getSalesChannel } from 'src/request/salesChannel/salesChannel';
import { EnumReducers } from 'src/store/constants';
import { assData } from 'src/tools/helper';
import { ChannelType } from 'src/types/common/SalesChannel';
import {
  CURRENT_SC_TIME_FORMAT,
  CURRENT_SC_DATE_FORMAT,
  CURRENT_SC_TIMEZONE,
  CURRENT_SC_UTC,
} from 'src/tools/constant';
import { generateKey } from '@/src/tools/getUserInfo';
export const fetchSalesChannel = createAsyncThunk(
  'fetchSalesChannel',
  async (data: { salesChannelUuid: string }) => {
    const { salesChannelUuid } = data;

    const response = await getSalesChannel(salesChannelUuid);
    return response;
  },
);

const target = (state) => {
  //console.log('state', state);
  return state[EnumReducers.currentSalesChannel];
};

const defaultData = {
  loading: true,
  salesChannelUuid: null,
  salesChannelName: '',
  uuid: null,
  name: null,
  currency: null,
  channelType: null,
  timezoneGmt: null,
  // nativeChannelType: {},
  // siteStyle: null,
  // availableSiteStyles: [],
};

const currentSalesChannel = createSlice({
  name: 'currentSalesChannel',
  initialState: defaultData,
  reducers: {
    onClearStoredSalesChannel(state) {
      assData(state, defaultData);
    },
    initSalesChannel(state, { payload }) {
      assData(state, payload);
    },

    // onStyleChange(state, action) {
    //   const { uuid, style } = action.payload;
    //   state.siteStyle = style;
    //   state.nativeChannelType[uuid] = { style ,error:false};
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSalesChannel.fulfilled, (state, action) => {
      //console.log('state.fulfilled');
      assData(state, action.payload || {});
      // const { timeFormat, dateFormat, timezoneGmt } = action.payload;
      const timeFormat = get(action.payload, 'timeFormat') || '';
      const dateFormat = get(action.payload, 'dateFormat') || '';
      const timezoneUTC = get(action.payload, 'timezoneGmt') || '';
      const timezone = get(action.payload, 'timezone') || '';
      const kT = generateKey(CURRENT_SC_TIME_FORMAT);
      const kD = generateKey(CURRENT_SC_DATE_FORMAT);
      const kU = generateKey(CURRENT_SC_UTC);
      const kS = generateKey(CURRENT_SC_TIMEZONE);
      sessionStorage.setItem(kT, timeFormat);
      sessionStorage.setItem(kD, dateFormat.toUpperCase());
      sessionStorage.setItem(kU, timezoneUTC);
      sessionStorage.setItem(kS, timezone);

      state.loading = false;
    });
    builder.addCase(fetchSalesChannel.pending, (state, action) => {
      //console.log('state.pending');
      state.loading = true;
    });
    builder.addCase(fetchSalesChannel.rejected, (state, action) => {
      //console.log('state.rejected');
      state.loading = false;
    });
  },
});

const getSalesChannelIsLoading = () => {
  return createSelector(
    (state: any) => {
      const t = get(target(state), 'loading');
      //console.log('loading', t);
      return t;
    },
    (loading) => {
      return loading;
    },
  );
};

const getCurrentSalesChannel = () => {
  return createSelector(
    (state: any) => {
      return target(state);
    },
    (state) => {
      return state;
    },
  );
};

const getIsCurrentSalesChannel = (uuid) => {
  return createSelector(
    (state: any) => {
      const t = get(target(state), 'uuid');
      return t;
    },
    (_uuid) => {
      return _uuid === uuid;
    },
  );
};

const isCurrentWebSalesChannel = () => {
  return createSelector(
    (state: any) => {
      const channelType = get(target(state), 'channelType');
      return channelType;
    },
    (channelType) => {
      return channelType === ChannelType.Website;
    },
  );
};

const getSalesChannelTimezoneGmt = () => {
  return createSelector(
    (state: any) => {
      const timezoneGmt = get(target(state), 'timezoneGmt');
      return timezoneGmt;
    },
    (v) => v,
  );
};

export {
  getCurrentSalesChannel,
  getIsCurrentSalesChannel,
  getSalesChannelIsLoading,
  getSalesChannelTimezoneGmt,
  // getAvaSiteStyles,
  // getCurrentSiteStyles,
  isCurrentWebSalesChannel,
};
export const { onClearStoredSalesChannel, initSalesChannel } =
  currentSalesChannel.actions;

export default currentSalesChannel.reducer;
